import { Component, EventEmitter, Inject, Input, Optional, Output } from '@angular/core';
import { AFP_RADIO_GROUP, RadioGroupComponent } from '../radio-group/radio-group';

let nextUniqueId = 0;

@Component({
  selector: 'afp-radio',
  templateUrl: './radio.html',
  styleUrls: ['./radio.scss']
})
export class RadioComponent {
  @Input() id?: string;
  @Input() name?: string;
  @Input() disabled: boolean = false;
  @Input() required: boolean = false;
  @Input() value: any;
  @Input() checked: boolean = false;
  @Output() change = new EventEmitter<any>();

  private readonly uid = nextUniqueId++;

  constructor(@Optional() @Inject(AFP_RADIO_GROUP) private group?: RadioGroupComponent) {}

  get inputId(): string {
    if (this.id) {
      return this.id;
    }
    return this.nameAttr ? `afp-radio-${this.nameAttr}-${this.uid}` : `afp-radio-${this.uid}`;
  }

  get nameAttr(): string | null {
    return this.name ?? this.group?.name ?? null;
  }

  get isDisabled(): boolean {
    return this.disabled || !!this.group?.disabled;
  }

  get isRequired(): boolean {
    return this.required || !!this.group?.required;
  }

  get isChecked(): boolean {
    return this.group ? this.group.value === this.value : this.checked;
  }

  onNativeChange(event: Event): void {
    const input = event.target as HTMLInputElement;
    input.checked = this.isChecked;
    if (this.isDisabled) return;
    event.stopPropagation();
    this.change.emit(this.value);
  }
}
